/**
 * @function getHashFragment - Get the hash fragment from the URL (params after a "#" in the URL)
 * @returns {string} - hash fragment
 */
export function getHashFragment() {
	return window.location.hash ? window.location.hash.split("#")[1] : null;
}
